import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router, ActivatedRoute } from "@angular/router";
import { PageEvent } from "@angular/material/paginator";
import { HttpParams } from "@angular/common/http";
import { TableService } from "../services/pager/pager";
import { OnboardingUserFilter } from "./onboarding-user.filter";
import { WebService } from "../services/web/web.service";
import { SpinnerService } from "../services/spinner/spinner.service";
import { ToastService } from "../services/notification/toast.service";
import { MatDialog } from "@angular/material/dialog";
import { SecurityService } from "../services/security.service";

@Component({
  selector: "app-onboarding-users",
  templateUrl: "./onboarding-users.component.html",
  styleUrls: ["./onboarding-users.component.scss"],
  standalone : false
})
export class OnboardingUsersComponent implements OnInit {
  // PARA MANEJO DE PANEL DE BUSQUEDA
  isOpenSearchPanel = false;
  filter = new OnboardingUserFilter(this.tableService.filter);

  statusOptions = [
    { value: 1, label: 'Activo' },
    { value: 2, label: 'Inactivo' }
  ];

  // PARA MANEJO DE TABLAS
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
  @ViewChild(MatSort) sort: MatSort | undefined;
  displayedColumns: string[] = [
    "name_user",
    "lastName_user",
    "email_user",
    "status_user",
    "actions",
  ];
  dataSource: any;

  constructor(
    public tableService: TableService<any>,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private webService: WebService,
    private spinner: SpinnerService,
    private toast: ToastService,
    private dialog: MatDialog,
    private securityService: SecurityService
  ) {
    this.tableService = new TableService();
  }

  ngOnInit(): void {
    console.log("📊 Inicializando componente de usuarios onboarding");
    const restored = this.tableService.loadListState("onboarding-users-list");
    if (restored && restored.filter) {
      console.log("🔄 Restaurando estado previo de la lista");
      this.restoreForBack(restored);
    }

    this.isOpenSearchPanel = true;
    this.list();
  }

  restoreForBack(restored: any) {
    this.filter = new OnboardingUserFilter(restored.filter);
    this.tableService.clearListState("onboarding-users-list");
    if (this.paginator) {
      this.paginator.pageIndex = restored.pageIndex;
      this.paginator.pageSize = restored.pageSize;
    }
  }

  list(event?: PageEvent) {
    console.log("📋 Cargando lista de usuarios onboarding");
    this.spinner.open();

    const partnerId = this.securityService.getTokenPartner();
    if (!partnerId) {
      console.warn("⚠️ No se encontró partner ID en sesión");
      this.spinner.close();
      return this.toast.showInfo("No se puede cargar usuarios porque no se encontró un partner.");
    }

    const pageIndex = event ? event.pageIndex : this.tableService.pager.pageIndex;
    const pageSize = event ? event.pageSize : this.tableService.pager.pageSize;

    let httpParams = new HttpParams()
      .set('pageIndex', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('partnerId', partnerId.toString());

    httpParams = this.filter.getHttpParams(httpParams);

    console.log(`🔍 Solicitando usuarios - Página: ${pageIndex}, Tamaño: ${pageSize}`);

    this.webService
      .get(
        this.webService.HOST + "/api/users/onboarding-admin",
        httpParams
      )
      .subscribe(
        (response) => {
          let users = response["result"];
          console.log(`✅ Usuarios cargados exitosamente: ${users.length} usuarios encontrados`);

          this.dataSource = new MatTableDataSource<any>(users);
          this.tableService.pager = response["pager"];
          this.tableService.selection.clear();
          this.spinner.close();
        },
        (err) => {
          console.error("❌ Error al cargar usuarios:", err.message || err);
          this.spinner.close();
          this.toast.showError(err);
        }
      );
  }

  search() {
    console.log("🔎 Ejecutando búsqueda de usuarios con filtros aplicados");
    this.tableService.filter = new OnboardingUserFilter(this.filter);
    this.router.navigate([], {
      queryParams: {
        name_user: this.filter.name_user,
        lastName_user: this.filter.lastName_user,
        email_user: this.filter.email_user,
        status_user: this.filter.status_user,
      },
    });
    this.list();
  }

  openSearchPanel(value: boolean) {
    this.isOpenSearchPanel = value;
    this.filter = new OnboardingUserFilter(this.filter);
  }

  reset() {
    console.log("🔄 Reseteando filtros de búsqueda");
    this.filter = new OnboardingUserFilter();
    this.tableService.filter = null;
    
    // Reiniciar el pager a valores por defecto
    this.tableService.pager = { pageIndex: 0, pageSize: 20 };
    
    // Reiniciar el paginador de Material si existe
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 20;
    }
    
    // Limpiar los query params de la URL
    this.router.navigate([], {
      queryParams: {},
      replaceUrl: true
    });
    
    // Recargar la lista sin filtros
    this.list();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  create() {
    console.log("➕ Navegando a crear usuario");
    this.memorizeForBack();
    this.router.navigate(["./create"], {
      relativeTo: this.activatedRoute,
      queryParamsHandling: "preserve",
    });
  }

  update(item: any) {
    console.log(`✏️ Navegando a editar usuario ID: ${item.id}`);
    this.memorizeForBack();
    this.router.navigate(["./" + item.id + "/update"], {
      relativeTo: this.activatedRoute,
      queryParamsHandling: "preserve",
    });
  }

  delete(item: any) {
    console.log(`🗑️ Solicitando confirmación para eliminar usuario ID: ${item.id}`);
    if (confirm(`¿Está seguro que desea dar de baja al usuario ${item.name_user} ${item.lastName_user} del onboarding?`)) {
      console.log(`🔄 Iniciando proceso de eliminación del usuario ID: ${item.id}`);
      this.spinner.open();
      const partnerId = this.securityService.getTokenPartner();
      
      const body = {
        partnerId: partnerId
      };
      
      this.webService
        .delete(body, `${this.webService.HOST}/api/users/onboarding-admin/${item.id}`)
        .subscribe(
          (response) => {
            console.log(`✅ Usuario ID: ${item.id} eliminado exitosamente`);
            this.spinner.close();
            this.toast.showSuccess("Usuario eliminado exitosamente");
            this.list();
          },
          (error) => {
            console.error(`❌ Error al eliminar usuario ID: ${item.id}:`, error.message || error);
            this.spinner.close();
            this.toast.showError(error);
          }
        );
    } else {
      console.log("ℹ️ Eliminación de usuario cancelada por el usuario");
    }
  }

  getStatusLabel(status: number): string {
    return status === 1 ? 'Activo' : 'Inactivo';
  }

  resendInvitation(item: any) {
    console.log(`📧 Solicitando confirmación para reenviar invitación al usuario ID: ${item.id}`);
    if (confirm(`¿Desea reenviar el correo de invitación de colaboración a este usuario?`)) {
      console.log(`🔄 Iniciando proceso de reenvío de invitación al usuario ID: ${item.id}`);
      this.spinner.open();
      const partnerId = this.securityService.getTokenPartner();
      
      const body = {
        partnerId: partnerId
      };
      
      this.webService
        .post(body, `${this.webService.HOST}/api/users/onboarding-admin/${item.id}/resend-welcome-email`)
        .subscribe(
          (response) => {
            console.log(`✅ Invitación reenviada exitosamente al usuario ID: ${item.id}`);
            this.spinner.close();
            this.toast.showSuccess("Invitación reenviada exitosamente");
          },
          (error) => {
            console.error(`❌ Error al reenviar invitación al usuario ID: ${item.id}:`, error.message || error);
            this.spinner.close();
            this.toast.showError(error);
          }
        );
    } else {
      console.log("ℹ️ Reenvío de invitación cancelado por el usuario");
    }
  }

  goBack() {
    this.router.navigate(["/my-portals"]);
  }

  memorizeForBack() {
    this.tableService.saveListState("onboarding-users-list", {
      filter: this.filter,
      pageIndex: this.paginator ? this.paginator.pageIndex : 0,
      pageSize: this.paginator ? this.paginator.pageSize : 10,
    });
  }
}
